export const en = {
    'search-input-text': 'Search',
    'video-stock-search-input-text': 'Search video library'
};
